export default "__VITE_ASSET__CrhxbZEb__"